import { StatsManfreditesQueryRequest } from './stats-manfredites.query.request';
export const createStatsManfreditesQueryRequestMock = (customValues = {}) => {
    const query = new StatsManfreditesQueryRequest();
    query.techIds = customValues.techIds ?? [1, 2];
    query.roleId = customValues.roleId ?? 1;
    query.withFluentEnglish = customValues.withFluentEnglish ?? true;
    query.location = customValues.location ?? 'Madrid';
    return query;
};
//# sourceMappingURL=stats-manfredites.query.request.mock.js.map